var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.93 2.47C19.64 -0.819998 14.29 -0.819998 11 2.47C9.41 4.06 8.53 6.18 8.53 8.44C8.53 10.27 9.12 12.01 9.48 12.74L0 22.22L3.18 25.4L12.66 15.92C13.44 16.31 15.2 16.87 16.96 16.87C19.12 16.87 21.28 16.05 22.93 14.4C26.22 11.11 26.22 5.76 22.93 2.47ZM22.22 13.69C19.32 16.59 14.6 16.59 11.7 13.69C10.3 12.29 9.52 10.42 9.52 8.43C9.52 6.44 10.29 4.58 11.7 3.17C13.15 1.72 15.05 1 16.96 1C18.87 1 20.77 1.73 22.22 3.17C25.12 6.07 25.12 10.79 22.22 13.69Z",
    fill: "#005E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4399 4.89L21.0899 5.24C22.0699 6.22 22.5999 7.51 22.5999 8.89001C22.5999 10.27 22.0599 11.57 21.0899 12.55C20.1099 13.53 18.8199 14.06 17.4299 14.06C16.0399 14.06 14.7499 13.52 13.7699 12.55L13.4199 12.9C14.4899 13.97 15.9099 14.56 17.4299 14.56C18.9399 14.56 20.3699 13.97 21.4399 12.9C22.5099 11.83 23.0999 10.41 23.0999 8.89001C23.0999 7.37001 22.5099 5.95 21.4399 4.88V4.89Z",
    fill: "#005E64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4,
    height: 25.4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupe);
export default __webpack_public_path__ + "static/media/lupe.fecc6e692dc33c64129bf04a2f564ff9.svg";
export { ForwardRef as ReactComponent };